import { render, staticRenderFns } from "./coomdsPrice.vue?vue&type=template&id=35d4a3af&scoped=true"
import script from "./coomdsPrice.vue?vue&type=script&lang=ts"
export * from "./coomdsPrice.vue?vue&type=script&lang=ts"
import style0 from "./coomdsPrice.vue?vue&type=style&index=0&id=35d4a3af&prod&lang=less&scoped=true"
import style1 from "./coomdsPrice.vue?vue&type=style&index=1&id=35d4a3af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4a3af",
  null
  
)

export default component.exports